import React from "react";
import "../../../styles/auth.css";

const FormInput = ({
  id,
  value,
  type = "text",
  label,
  placeholder = "",
  disabled = false,
  customClass = "",
  maxLength,
  onChange,
}) => {
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        className={`form-control ${customClass}`}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default FormInput;
